import { Chip } from '@mui/material';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import { useTranslation } from 'react-i18next';

interface OnboardingLauncherProps {
  percent: number;
  onClick: () => void;
}

export function OnboardingLauncher({ percent, onClick }: OnboardingLauncherProps) {
  const { t } = useTranslation();

  return (
    <Chip
      icon={<RocketLaunchOutlinedIcon sx={{ fontSize: 16 }} />}
      label={t('onboarding.launcher.label', { percent })}
      size="small"
      onClick={onClick}
      sx={{
        bgcolor: 'rgba(45, 212, 191, 0.08)',
        border: '1px solid rgba(45, 212, 191, 0.2)',
        color: 'primary.light',
        fontWeight: 500,
        fontSize: 11,
        cursor: 'pointer',
        '&:hover': {
          bgcolor: 'rgba(45, 212, 191, 0.14)',
        },
      }}
    />
  );
}
